import React, { useEffect } from "react";
import { CheckCircle2, ShieldCheck, Calendar, Globe, FileText, CreditCard } from "lucide-react";
import { tr } from "zod/v4/locales";

export default function QuotationDataMiddle({ reportData }) {

    useEffect(() => {
console.log("report data from midddle quotation", reportData?.idsApi);

    }, [reportData])

    if (!reportData) return null;

  // Calculate totals
  const softwareCost = parseFloat(reportData.softwareCost) || 0;
  const amcCost = parseFloat(reportData.amcCost) || 0;
  const idsPayCost = reportData.idsPayIntegration === "yes" ? parseFloat(reportData.idsPayCost) || 0 : 0;
  const thirdPartyCost = reportData.thirdPartyIntegration === "yes" ? parseFloat(reportData.thirdPartyCost) || 0 : 0;
  const discount = parseFloat(reportData.discount) || 0;
  const subtotal = softwareCost + amcCost + idsPayCost + thirdPartyCost ;
  const grandTotal = Math.max(0, subtotal - discount);

  return (
    <div className="mx-auto max-w-[800px] mb-6 min-h-screen bg-white p-8 sm:p-12 shadow-xl  border border-slate-200 text-slate-800 print:shadow-none print:border-none print:p-0">
      
      {/* Top Header Banner */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center border-b-2 border-slate-900 pb-6 mb-8 gap-4">
        <div>
          <span className="inline-block px-3 py-1 bg-blue-100 text-blue-800 text-xs font-bold rounded-full uppercase tracking-wider mb-2">
            Official Quotation
          </span>
          <h2 className="text-2xl font-black text-slate-900 tracking-tight">
            Software Development Proposal
          </h2>
        </div>
        <div className="text-left sm:text-right text-xs text-slate-500 space-y-1">
          <p><span className="font-semibold text-slate-700">Date:</span> {reportData.quotationDate || "N/A"}</p>
          <p><span className="font-semibold text-slate-700">Domain Managed By:</span> {reportData.domainManagedBy || "IDSPay"}</p>
          {reportData.deliveryDate && (
            <p><span className="font-semibold text-slate-700">Est. Delivery:</span> {reportData.deliveryDate}</p>
          )}
        </div>
      </div>

      {/* Client & Software Overview Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 bg-slate-50 p-6 rounded-xl border border-slate-200/80 mb-8">
        <div>
          <p className="text-xs font-bold uppercase tracking-wider text-slate-400 mb-1">Prepared For</p>
          <h3 className="text-xl font-bold text-slate-900">{reportData.clientName || "Valued Client"}</h3>
        </div>
        <div>
          <p className="text-xs font-bold uppercase tracking-wider text-slate-400 mb-1">Software Type</p>
          <h3 className="text-xl font-bold text-blue-900">{reportData.softwareType || "Custom Software"}</h3>
        </div>
      </div>

      {/* Access Portals & Modules */}
      {reportData.selectedLogins && reportData.selectedLogins.length > 0 && (
        <div className="mb-8">
          <h4 className="text-sm font-bold uppercase tracking-wider text-slate-500 mb-3 flex items-center gap-2">
            <ShieldCheck className="h-4 w-4 text-blue-600" /> Included Access Portals
          </h4>
          <div className="flex flex-wrap gap-2">
            {reportData.selectedLogins.map((login, idx) => (
              <span
                key={idx}
                className="inline-flex items-center gap-1.5 px-3 py-1 bg-slate-100 text-slate-700 rounded-lg text-xs font-semibold border border-slate-200"
              >
                <CheckCircle2 className="h-2 px-4 w-2 px-4 text-blue-600" />
                {login}
              </span>
            ))}
          </div>
        </div>
      )}

      {/* IDSPay API Breakdown table */}

       {/* Modern Styled Header */}
    <div className="flex items-center justify-start gap-2 mb-4">
      <h3 className="text-lg font-bold text-slate-800">
        IDSPay API Integration:
      </h3>
      <span className={`px-3 py-1 text-xs font-semibold tracking-wide ${reportData?.idsPayIntegration === "yes" ? " bg-green-100 text-green-700 " : "bg-red-100 text-red-700"} uppercase  rounded-full`}>
        {reportData?.idsPayIntegration}
      </span>
    </div>

{reportData?.idsPayIntegration === "yes" && (
  <div className="mb-10">
   
    <div className="overflow-hidden border rounded-xl border-slate-200">
      <table className="w-full text-xs text-left border-collapse">
        <thead>
          <tr className=" font-bold tracking-wider text-white uppercase bg-slate-900">
            <th className="p-2 px-4">API Service Name</th>
            <th className="p-2 px-4">API Call Charge</th>
            <th className="p-2 px-4 text-right">Integration Fee (₹)</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-slate-200 text-slate-700">
          {reportData?.idsApi?.length > 0 ? (
            reportData.idsApi.map((item, idx) => (
              <tr key={idx} className="transition-colors hover:bg-slate-50">
                <td className="p-2 px-4 font-semibold">{item?.service}</td>
 <td className="p-2 px-4 font-medium text-right">
                  ₹{item?.charge?.toLocaleString("en-IN")}
                </td>                <td className="p-2 px-4 font-medium text-right">
                  ₹{item?.fee?.toLocaleString("en-IN")}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={3} className="p-6 text-center text-slate-500 italic">
                No data available
              </td>
            </tr>
          )}
        </tbody>
        <tfoot>
          <tr className="text-sm font-bold bg-slate-100 text-slate-900">
            <td colSpan={2} className="p-2 px-4 text-right">Total Cost</td>
            <td className="p-2 px-4 text-right text-blue-900">
              ₹{reportData?.idsPayCost?.toLocaleString("en-IN") || 0}
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
)}

{/* Third Party API Breakdown table */}

 {/* Modern Styled Header */}
    <div className="flex items-center justify-start gap-2 mb-4">
      <h3 className="text-lg font-bold text-slate-800">
        Third Party API Integration:
      </h3>
      <span className={`px-3 py-1 text-xs font-semibold tracking-wide uppercase ${reportData?.thirdPartyIntegration === "yes" ? " bg-green-100 text-green-700 " : "bg-red-100 text-red-700"} rounded-full`}>
         {reportData?.thirdPartyIntegration}
      </span>
    </div>

  {reportData?.thirdPartyIntegration === "yes" && (
    <div className="mb-10">
    

      <div className="overflow-hidden border rounded-xl border-slate-200">
        <table className="w-full text-xs text-left border-collapse">
          <thead>
            <tr className=" font-bold tracking-wider text-white uppercase bg-slate-900">
              <th className="p-2 px-4">API Service Name</th>
              <th className="p-2 px-4 text-right">Integration Fee (₹)</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-200 text-slate-700">
            {reportData?.thirdPartyApis?.length > 0 ? (
              reportData.thirdPartyApis.map((item, idx) => (
                <tr key={idx} className="transition-colors hover:bg-slate-50">
                  <td className="p-2 px-4 font-semibold">{item?.apiName}</td>
                  <td className="p-2 px-4 font-medium text-right">
                    ₹{item?.amount?.toLocaleString("en-IN")}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={2} className="p-6 text-center text-slate-500 italic">
                  No data available
                </td>
              </tr>
            )}
          </tbody>
          <tfoot>
            <tr className="text-sm font-bold bg-slate-100 text-slate-900">
              <td className="p-2 px-4 text-right">Total Cost</td>
              <td className="p-2 px-4 text-right text-blue-900">
                ₹{reportData?.thirdPartyCost?.toLocaleString("en-IN") || 0}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  )}

      {/* Financial Breakdown Table */}
      <div className="mb-8 overflow-hidden rounded-xl border border-slate-200">
        <table className="w-full text-left text-xs border-collapse">
          <thead>
            <tr className="bg-slate-900 text-white font-bold uppercase tracking-wider">
              <th className="p-2 px-4">Particular</th>
              <th className="p-2 px-4 text-right">Amount (₹)</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-200 text-slate-700">
            <tr>
              <td className="p-2 px-4 font-semibold">Software Licensing & Development Cost</td>
              <td className="p-2 px-4 text-right font-medium">₹{softwareCost.toLocaleString("en-IN")}</td>
            </tr>
            {reportData.idsPayIntegration === "yes" && (
              <tr>
                <td className="p-2 px-4 font-semibold">IDSPay API Integration Fee</td>
                <td className="p-2 px-4 text-right font-medium">₹{idsPayCost.toLocaleString("en-IN")}</td>
              </tr>
            )}
            {reportData.thirdPartyIntegration === "yes" && (
              <tr>
                <td className="p-2 px-4 font-semibold">Third-Party API Integration Fee</td>
                <td className="p-2 px-4 text-right font-medium">₹{thirdPartyCost.toLocaleString("en-IN")}</td>
              </tr>
            )}
           
          </tbody>
          <tfoot>
             {reportData.amcCost && (
              <tr className="bg-amber-50/60 text-amber-900 text-xs border-t border-amber-200">
                <td className="p-2 px-4 font-semibold">Annual Maintenance Cost (AMC)</td>
                <td className="p-2 px-4 text-right font-bold">₹{parseFloat(reportData.amcCost).toLocaleString("en-IN")} / yr</td>
              </tr>
            )}
            <tr className="bg-slate-100 font-bold text-slate-900 text-sm">
              <td className="p-2 px-4">Total Development Cost</td>
              <td className="p-2 px-4 text-right text-blue-900">₹{subtotal.toLocaleString("en-IN")}</td>
            </tr>
           
             {discount > 0 && (
              <tr className="text-green-700 bg-green-50/50">
                <td className="p-2 px-4 font-semibold">Discount Applied</td>
                <td className="p-2 px-4 text-right font-medium">- ₹{discount.toLocaleString("en-IN")}</td>
              </tr>
            )}

             <tr className="bg-slate-100 font-bold text-slate-900 text-sm">
              <td className="p-2 px-4">Final Development Cost</td>
              <td className="p-2 px-4 text-right text-blue-900">₹{grandTotal.toLocaleString("en-IN")}</td>
            </tr>
          </tfoot>
        </table>
      </div>


      {/* API Features and Specifications (Rich Text Quill Content) */}
{reportData?.quillContent && (
  <div className="mb-10 overflow-hidden border rounded-xl border-slate-200">
    <div className="flex items-center gap-2 p-2 px-4 text-xs font-bold tracking-wider text-white uppercase bg-slate-900">
      <FileText className="w-4 h-4 text-slate-300" />
      API Features & Specifications
    </div>

    <div
      className="
        p-5 bg-white max-w-none
        [&_ul]:list-disc
        [&_ul]:pl-6
        [&_ol]:list-decimal
        [&_ol]:pl-6
        [&_li]:ml-1

          [&_h1]:text-3xl
        [&_h1]:font-bold
        [&_h1]:mb-4

        [&_h2]:text-2xl
        [&_h2]:font-bold
        [&_h2]:mb-3

        [&_h3]:text-xl
        [&_h3]:font-bold
        [&_h3]:mb-3

        [&_h4]:text-lg
        [&_h4]:font-bold
        [&_h4]:mb-2

        [&_h5]:text-sm
        [&_h5]:font-bold
        [&_h5]:mb-2
      "
      dangerouslySetInnerHTML={{
        __html: reportData.quillContent,
      }}
    />
  </div>
)}

     {/* Payment Schedule / Bill Style */}
{reportData.paymentModes && reportData.paymentModes.length > 0 && (
  <div className="mb-8">
    <div className="mb-2 flex items-center justify-between  pb-2">
      <h4 className="text-sm font-bold uppercase tracking-wide text-slate-800">
        Payment Terms
      </h4>

    </div>

    <div className="border border-slate-300 bg-white">
      {/* Header */}
      {/* <div className="grid grid-cols-[1fr_160px] border-b border-slate-400 bg-slate-100 px-3 py-2 text-xs font-bold uppercase tracking-wide text-slate-700">
        <div>Particulars</div>
        <div className="text-right">Amount (₹)</div>
      </div> */}

      {/* Rows */}
      {reportData.paymentModes.map((pm, idx) => (
        <div
          key={idx}
          className="grid grid-cols-[1fr_160px] border-b border-slate-200 px-3 py-2.5 text-sm"
        >
          <div className="text-slate-700">
            {pm.remark || `Payment #${idx + 1}`}
          </div>

          <div className="text-right font-medium text-slate-800">
            {parseFloat(pm.amount || 0).toLocaleString("en-IN", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </div>
        </div>
      ))}

      {/* Total */}
      <div className="grid grid-cols-[1fr_160px] border-t-2 border-slate-700 px-3 py-3 text-sm">
        <div className="font-bold uppercase text-slate-800">
          Total Amount
        </div>

        <div className="text-right font-bold text-slate-900">
          ₹
          {reportData.paymentModes
            .reduce(
              (sum, pm) => sum + Number(pm.amount || 0),
              0
            )
            .toLocaleString("en-IN", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
        </div>
      </div>
    </div>
  </div>
)}

      

    </div>
  );
}